import { AttendeeData, SectionType, AllContacts } from './attendeeUtils'
import { ATTENDANCE_STATUS } from 'common/constants/constants'

export interface SearchManagerProps {
    allContacts?: AllContacts
    invitedAttendees: AttendeeData[]
    presentAttendees: AttendeeData[]
    absentAttendees: AttendeeData[]
}

export class SearchManager {
    private props: SearchManagerProps
    private searchOptionsCache: {
        invited: AttendeeData[]
        present: AttendeeData[]
        absent: AttendeeData[]
    } | null = null

    constructor(props: SearchManagerProps) {
        this.props = props
    }

    public updateProps(newProps: SearchManagerProps) {
        this.props = newProps
    }

    public getSearchOptionsForSection = (section: SectionType): AttendeeData[] => {
        const { allContacts, invitedAttendees, presentAttendees, absentAttendees } = this.props

        if (!allContacts) {
            return []
        }

        if (this.searchOptionsCache) {
            return this.searchOptionsCache[section]
        }

        const existingIds = new Set<string | number>()
        const existingNames = new Set<string>()

        const combinedSectionData = [...invitedAttendees, ...presentAttendees, ...absentAttendees]

        combinedSectionData.forEach((attendee) => {
            existingIds.add(attendee.id)
            existingNames.add((attendee.name || attendee.text || '').toLowerCase())
        })

        const keys = Object.keys(allContacts)
        const filtered = keys.filter((key) => {
            const contact = allContacts[key]
            const contactName = contact.attributes.displayName.toLowerCase()

            return !existingIds.has(key) && !existingNames.has(contactName)
        })

        const searchOptions = filtered.map((key) => {
            const item = allContacts[key]

            return {
                text: item.attributes.displayName,
                name: item.attributes.displayName,
                email: item.attributes.email || null,
                id: item.id,
                value: item.attributes.displayName
            }
        })

        this.searchOptionsCache = {
            invited: searchOptions,
            present: searchOptions,
            absent: searchOptions
        }

        return searchOptions
    }

    public renderAttendeesDataSourceForThreeSections = (
        _section1Data: AttendeeData[],
        _section2Data: AttendeeData[],
        _section3Data: AttendeeData[]
    ): AttendeeData[] => {
        this.searchOptionsCache = null
        return this.getSearchOptionsForSection(ATTENDANCE_STATUS.PRESENT as SectionType)
    }

    public clearCache = (): void => {
        this.searchOptionsCache = null
    }
}
